import Dimmer from 'semantic-ui-react/dist/es/modules/Dimmer';
import './Dimmer.css';

export default Dimmer;
